// Copyright (c) StrangeBee 2023

import React from 'react';
import { ExtractProps } from '@Molecules/Details/Details';
import { THDatePicker } from '@Molecules/Inputs/THDatePicker/THDatePicker';
import { THMarkdown } from '@Molecules/Inputs/THMarkdown/THMarkdown';
import { THForm } from '@Molecules/THForm/THForm';
import { normalizeDate } from '@Helpers/date';
import { onCaseImageUpload, onOrganisationImageUpload } from '@Helpers/download';

import './extractData.scss';

interface ExtractDataProps {
    locale: (label: string) => string;
    hasPermissions: boolean;
    caseId?: string;
}

export const extractData = ({ locale, hasPermissions, caseId }: ExtractDataProps): Record<string, ExtractProps> => ({
    'extraData.patternParent.patternId': {
        name: locale('procedure.details.techniqueParent'),
        className: 'ttp-drawer__section',
    },
    'extraData.patternParent.name': {
        name: locale('procedure.details.nameTechniqueParent'),
        className: 'ttp-drawer__section',
    },
    tactic: {
        name: locale('procedure.details.tactic'),
        className: 'ttp-drawer__section',
    },
    patternId: {
        name: locale('procedure.details.technique'),
        className: 'ttp-drawer__section',
    },
    'extraData.pattern.name': {
        name: locale('procedure.details.techniqueName'),
        className: 'ttp-drawer__section',
    },
    occurDate: {
        className: 'ttp-drawer__section',
        isForce: true,
        render: () => (
            <THForm.Item name="occurDate" label={locale('procedure.details.occur-date')} normalize={normalizeDate}>
                <THDatePicker borderless disabled={!hasPermissions} showTime />
            </THForm.Item>
        ),
    },
    description: {
        className: 'ttp-drawer__section',
        isForce: true,
        render: () => (
            <THForm.Item name="description" label={locale('procedure.details.procedure')}>
                <THMarkdown
                    borderless
                    disabled={!hasPermissions}
                    onImageUpload={caseId ? onCaseImageUpload(caseId) : onOrganisationImageUpload}
                />
            </THForm.Item>
        ),
    },
});
